import React, { useEffect, useState, useMemo } from 'react'
import styles from '../styles.module.scss'
import { arrowLeft } from '../../../assets/svg/dashboard/main'
import { useHistory } from 'react-router-dom'
import { Check, Input, Select } from '../../../assets/NewDashboard'
import ReactLoader from 'react-loader'
import { BACKEND_URL_PREFIX, OKIN_OPTIONS } from '../../../utils/const'
import { buildDefaultHeaders } from '../../../actions/helper'
import { useSelector } from 'react-redux'

const EDUCATION_LEVELS = [
  { value: 1, label: 'Высшее образование (ВО)' },
  { value: 2, label: 'СПО' },
]

const EduProgram = () => {
  const history = useHistory()
  const state = useSelector(state => state)

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [educationLevel, setEducationLevel] = useState(1)
  const [okinId, setOkinId] = useState(0)
  const [search, setSearch] = useState('')

  const fetchData = async () => {
    setLoading(true)
    try {
      const params = new URLSearchParams({
        education_level: educationLevel,
        okin_id: okinId,
      }).toString()

      const response = await fetch(
        `${BACKEND_URL_PREFIX}/epcr/stats?${params}`,
        buildDefaultHeaders({ auth: state.auth })
      )

      if (response.ok) {
        const result = await response.json()
        setData(result)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [educationLevel, okinId])

  const filteredData = useMemo(() => {
    if (!search) return data
    return data.filter(item =>
      item.program_name.toLowerCase().includes(search.toLowerCase())
    )
  }, [data, search])

  const goTo = (link) => (e) => {
    e.stopPropagation()
    history.push(link)
  }

  const renderComplianceCell = (value, onClick) => {
    const mode = value ? 'complete' : 'notComplete'
    const text = value ? 'соответствует' : 'не соответствует'
    return (
      <td onClick={onClick} style={onClick ? { cursor: 'pointer' } : {}}>
        <div>
          <Check mode={mode} />
          {text}
        </div>
      </td>
    )
  }

  const goToStructure = (qDemandId) => () => {
    history.push(`/dashboard_new/edu_prog/structure/${qDemandId}`)
  }

  const goToOutcomesCompliance = (qDemandId) => () => {
    history.push(`/dashboard_new/outcomes_compliance/${qDemandId}`)
  }
  
  const goToConditionsCompliance = (qDemandId) => () => {
    history.push(`/dashboard_new/conditions_compliance/${qDemandId}`)
  }

  const renderRow = (item, index) => {
    return (
      <tr key={index}>
        <td>
          <div>
            <Check mode="complete" />
            {item.program_name}
          </div>
        </td>
        {renderComplianceCell(item.outcomes_compliance, goToOutcomesCompliance(item.q_demand_id))}
        {renderComplianceCell(item.conditions_compliance, goToConditionsCompliance(item.q_demand_id))}
        {renderComplianceCell(item.structure_compliance, goToStructure(item.q_demand_id))}
      </tr>
    )
  }

  return (
    <div className={styles.eduProgramWrap}>
      <div onClick={goTo('/dashboard_new')}>
        <div>{arrowLeft}</div>
        <h2>Соответствие образовательных программ требованиям</h2>
      </div>
      <div>
        <div className={styles.selectsRow}>
          <Select
            value={educationLevel}
            onChange={(e) => setEducationLevel(Number(e.target.value))}
            disabled={loading}
          >
            {EDUCATION_LEVELS.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </Select>
          <Select
            value={okinId}
            onChange={(e) => setOkinId(Number(e.target.value))}
            disabled={loading}
          >
            {OKIN_OPTIONS.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </Select>
        </div>
        <div className={styles.searchInput}>
          <Input onChange={setSearch} placeholder="Поиск" />
        </div>
      </div>
      <ReactLoader loaded={!loading} color='#5b76e5'>
        <table>
          <thead>
            <tr>
              <th>Наименование образовательной программы</th>
              <th>Соответствие результатам освоения</th>
              <th>Соответствие условиям реализации</th>
              <th>Соответствие структуре основных образовательных программ</th>
            </tr>
          </thead>
          <tbody>
            {filteredData?.length > 0 ? (
              filteredData.map(renderRow)
            ) : (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>Список пуст</td>
              </tr>
            )}
          </tbody>
        </table>
      </ReactLoader>
    </div>
  )
}

export default EduProgram
